import styled from 'styled-components';

const Box = styled.div(({ theme }) => ({
  margin: theme.spacing.medium
}));

export default Box;
